import styled from 'styled-components'

export const Container = styled.header`
  background-image: url('/bg-header.jpg');
  background-repeat: no-repeat;
  background-color: #2b3c5b;
  background-size: cover;
  width: 100%;
  padding: 0;
  img {
    width: 100%;
    max-width: 70px;
  }
  img.logo {
    /* versão negativa da marca (branco + ciano), porque o header é escuro */
    width: auto;
    max-width: none;
    height: 42px;
  }
  button.theme_switcher {
    display: block;
    width: 100%;
    margin-top: 1rem;
    background: ${props => (props.theme.name === 'light' ? '#2b3c5b' : '#eee')};
    color: ${props => (props.theme.name === 'light' ? '#eee' : '#2b3c5b')};
    padding: 0.7rem 1rem;
    text-transform: uppercase;
    font-weight: 900;
  }
  > div.cont {
    color: #e4e4e4;
    padding: 0.8rem 1.5rem;
    height: 60px;
    /* centraliza a linha quando algum item (a logo) é mais alto que o espaço
       interno da barra, senão ele encosta no topo */
    align-content: center;
    h2 {
      button {
        color: #fff;
        font-size: 1.2rem;
        font-weight: 700;
      }
    }
    .widgets {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      button {
        outline: none !important;
        border: none !important;
        svg {
          font-size: 2rem;
        }
      }
      .dropdown-toggle::after {
        display: none;
      }
    }
  }

  @media screen and (max-width: 650px) {
    .company_logged {
      display: none;
    }
  }
`

/* H5 — área de conta: o gatilho no cabeçalho e o cartão que ele abre. */
export const UserMenuContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 18px;
  margin-left: 1rem;

  .user_menu__divider {
    width: 1px;
    height: 26px;
    background: rgba(255, 255, 255, 0.22);
  }

  .user_menu__trigger {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 4px 6px;
    border: none;
    border-radius: 999px;
    background: none;
    color: #fff;
    transition: background-color 160ms;
    &:hover,
    &.is-open {
      background: rgba(255, 255, 255, 0.1);
    }
    &:focus-visible {
      outline: 2px solid #f5a623;
      outline-offset: 2px;
    }
    /* A seta acompanha o estado do menu. */
    .user_menu__chevron {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.75);
      transition: transform 160ms;
    }
    &.is-open .user_menu__chevron {
      transform: rotate(180deg);
    }
  }

  .user_menu__avatar {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #3e79c4;
    color: #fff;
    font-size: 12.5px;
    font-weight: 800;
    line-height: 34px;
    text-align: center;
    /* Cor fixa: o avatar identifica pela inicial, não por uma cor que o usuário teria de decorar. */
    &.is-card {
      width: 38px;
      height: 38px;
      background: #eaf1fa;
      color: #1b56a3;
      font-size: 13px;
      line-height: 38px;
    }
  }

  .user_menu__identity {
    display: flex;
    align-items: center;
    strong {
      font-size: 13.5px;
      font-weight: 700;
      line-height: 1;
      color: #fff;
    }
  }

  .user_menu__card {
    position: absolute;
    top: calc(100% + 9px);
    right: 0;
    z-index: 1000000001;
    width: 280px;
    background: #fff;
    border-radius: 11px;
    box-shadow: 0 12px 30px rgba(16, 24, 40, 0.2);
    overflow: hidden;
    text-align: left;
  }

  .user_menu__header {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 15px 16px;
    border-bottom: 1px solid #f0f2f5;
  }
  .user_menu__header_text {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    strong {
      font-size: 14px;
      font-weight: 700;
      line-height: 1.3;
      color: #101828;
    }
    small {
      font-size: 11.5px;
      line-height: 1.3;
      color: #7b8794;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .user_menu__group {
    padding: 6px;
    &.is-footer {
      border-top: 1px solid #f0f2f5;
    }
    > button {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 11px;
      padding: 10px 11px;
      border: none;
      border-radius: 7px;
      background: none;
      font-size: 13.5px;
      font-weight: 600;
      color: #344054;
      text-align: left;
      transition: background-color 120ms;
      svg {
        flex-shrink: 0;
        font-size: 19px;
        color: #7b8794;
      }
      &:hover {
        background: #f7f9fc;
      }
      &:focus-visible {
        outline: 2px solid #2f5fa0;
        outline-offset: -2px;
      }
      &.is-danger {
        color: #b42318;
        svg {
          color: #b42318;
        }
        &:hover {
          background: #fef3f2;
        }
      }
    }
  }
`

/* H7 — relógio do cabeçalho, no lugar do antigo contador de sessão. */
export const ClockContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  /* O container dos ícones não tem gap — cada um traz a própria margem —, então o divisor
     precisa do respiro à direita ou encosta no primeiro ícone. */
  margin-right: 18px;

  > time {
    display: flex;
    align-items: baseline;
    gap: 7px;
    /* Largura estável: sem isso a linha inteira se mexe a cada virada de minuto. */
    font-variant-numeric: tabular-nums;
  }

  .clock__date {
    font-size: 11.5px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
  }

  .clock__time {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
  }

  .clock__divider {
    width: 1px;
    height: 26px;
    background: rgba(255, 255, 255, 0.22);
  }
`
